import * as R from 'ramda';

const addScheduledReport = store => async (state, newScheduledReport) => {
    const currentState = store.getState();
    const userClientId = state.user.selectedUserClientId;
    const oldScheduledReports =
        currentState.clients[userClientId].scheduledReports;
    const index = oldScheduledReports.findIndex(
        schedule => schedule.scheduleId === newScheduledReport.scheduleId,
    );

    if (index == -1) {
        oldScheduledReports.unshift(newScheduledReport);
    } else {
        oldScheduledReports[index] = newScheduledReport;
    }

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'scheduledReports'],
            oldScheduledReports,
            store.getState(),
        ),
        true,
    );
};

export default addScheduledReport;
